import React from 'react';

import css from '@emotion/css';
import styled from '@emotion/styled';

import type { IProps } from './tooltip';

const TooltipContainer = styled.div<IProps>`
  top: ${(props: IProps) =>
    props.position === 'TOP' && props.activeTooltipTopCSS ? '-12px' : undefined};
  bottom: ${(props: IProps) =>
    props.position === 'BOTTOM' && props.activeTooltipBottomCSS ? '-12px' : undefined};
  margin: ${(props) => {
    const margins = [props.marginTop, props.marginRight, props.marginBottom, props.marginLeft];
    return margins.map((x) => `${x ?? 0}px`).join(' ');
  }};
  position: absolute;
  box-sizing: border-box;
  border-radius: 0.5rem;
  width: ${(props) => props.width};
  background: ${(props) => props.backgroundColor || '#475569'};
  transform: ${(props) => {
    const { position, transform } = props;
    const transforms: string[] = [];

    return transforms
      .addNotEmpty(transform)
      .addIf(position === 'TOP', 'translateY(-10px) translateY(-100%)', 'translateY(30px)')
      .toClassNames();
  }} translateX(-50%);
  padding: 1rem 0.5rem;
  border: 1px solid gray;
  overflow: unset !important;
  text-align: initial;
  z-index: 50;

  &:after {
    content: '';
    position: absolute;
    bottom: ${(props) => (props.position === 'TOP' ? '-6px' : undefined)};
    top: ${(props) => (props.position === 'BOTTOM' ? '-6px' : undefined)};
    left: ${(props) => props.alignTriangle};
    transform: ${(props) => props.transformTriangle ?? ''} translateX(50%) rotate(45deg);
    width: 12px;
    height: 12px;
    border-width: 1px;
    border-style: solid;
    border-color: ${(props) => props.backgroundColor || '#475569'};
    border-top-color: ${(props) => (props.position === 'BOTTOM' ? 'gray' : props.backgroundColor)};
    border-left-color: ${(props) => (props.position === 'BOTTOM' ? 'gray' : props.backgroundColor)};
    border-right: ${(props) => (props.position === 'TOP' ? 'gray' : props.backgroundColor)};
    border-bottom: ${(props) => (props.position === 'TOP' ? 'gray' : props.backgroundColor)};
    background: ${(props) => props.backgroundColor || '#475569'};
  }
`;

TooltipContainer.defaultProps = {
  activeTooltipTopCSS: false,
  activeTooltipBottomCSS: false,
  alignTriangle: '50%',
  position: 'TOP',
  width: '300px'
};

export default TooltipContainer;
